'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var CountDown_module = require('../styles/CountDown.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description CountDown component.
 *
 * @component
 * @example
 * ```jsx
 * <CountDown from={0} to={987654} />
 * ```
 */
const CountDown = React__namespace.forwardRef((props, ref) => {
    const { from, to, speed, interval, formatter, className, ...restProps } = props;
    const cx = reactUtils.useStyles(CountDown_module.default);
    const value = reactUtils.useCountDown({ from, to, speed, interval, formatter });
    const classNames = cx(className, 'container');
    return (React__namespace.createElement("span", { ref: ref, "data-qa": "CountDown", className: classNames, ...restProps }, value));
});
CountDown.defaultProps = {
    from: 0,
    speed: 500,
    interval: 100,
};
CountDown.displayName = 'CountDown';

exports.CountDown = CountDown;
//# sourceMappingURL=CountDown.js.map
